const translations: Record<string, string> = {
  "ak_sd_night_no_generation_the_night_draw_of": "Ніч: генерації немає, у графік внесено нічний відбір 0,05",
  "ak_sd_night_no_generation": "Ніч: генерації немає",
  "ak_sd_before_sunrise": "До сходу сонця",
  "ak_sd_sunrise_the_model_gives_0_6_with_a_0_4": "Схід: модель дає 0,6 при коридорі 0,4–0,8",
  "ak_sd_morning_ramp_historically_the_largest": "Ранковий підйом — історично найбільша похибка",
  "ak_sd_ramp_continues_variable_cloud_cover": "Підйом триває, хмарність змінна",
  "ak_sd_price_is_already_low_but_the_battery_i": "Ціна вже низька, але батарея ще не заповнена",
  "ak_sd_zero_hour_all_generation_goes_to_the_b": "Нульова година: уся генерація — в батарею",
  "ak_sd_zero_hour_the_battery_takes_the_remain": "Нульова година: батарея добирає залишок",
  "ak_sd_battery_is_full_the_remaining_2_0_goes": "Батарея заповнилась, залишок 2,0 — у мережу",
  "ak_sd_delivery_per_schedule": "Відпуск за графіком",
  "ak_sd_generation_decline": "Спад генерації",
  "ak_sd_sunset": "Захід сонця",
  "ak_sd_almost_no_generation_price_is_rising": "Генерації майже немає, ціна росте",
  "ak_sd_discharge_window_2nd_most_expensive_ho": "Вікно розряду: 2-га за ціною година доби",
  "ak_sd_discharge_window_the_most_expensive_ho": "Вікно розряду: найдорожча година доби",
  "ak_sd_battery_is_empty_no_reserve_for_a_thir": "Батарея порожня, резерву на третю годину немає",
  "ak_sd_night": "Ніч",
  "ak_sd_2_inverters_of_tko_3_taken_out_of_serv": "Виведено 2 інвертори ТКО-3, планово до 16.10",
  "ak_sd_connection_to_ems_box_lost_for_6_min_d": "Обрив звʼязку з EMS Box, 6 хв — дані відновлено",
  "ak_sd_commercial_dispatcher": "Комерційний диспетчер",
  "ak_sd_vadym": "Вадим",
  "ak_sd_forecast_quality_and_volumes": "якість прогнозу й обсяги",
  "ak_sd_today_09_12": "сьогодні 09:12",
  "ak_sd_trader": "Трейдер",
  "ak_sd_olya": "Оля",
  "ak_sd_prices_and_charge_discharge_windows": "ціни та вікна заряду-розряду",
  "ak_sd_today_09_31": "сьогодні 09:31",
  "ak_sd_technical_dispatcher": "Технічний диспетчер",
  "ak_sd_vacancy": "вакансія",
  "ak_sd_technical_state_and_restrictions": "технічний стан і обмеження",
  "ak_sd_trading_schedule_for_elios_luchky_sola": "Торговий графік на {{d}} · СЕС «Еліос Лучки»",
  "ak_sd_draft_prepared_by_the_model_at_08_40": "Чернетку склала модель о 08:40 ·",
  "ak_sd_approved_by": "погодив {{p}} · {{at}}",
  "ak_sd_waiting": "чекає · {{p}}",
  "ak_sd_if_at": "Якщо о",
  "ak_sd_not_everyone_has_approved_the_system_w": "погодять не всі — система подасть свою версію й запише в журнал, хто не глянув. Непідписаний графік кращий за відсутній: доба без графіка коштувала у вересні 33 тис. грн.",
  "ak_sd_mwh": "МВт·год",
  "ak_sd_k_uah": "тис. грн",
  "ak_sd_of": "{{a}} з {{b}}",
  "ak_sd_charge_discharge_mw": "заряд {{c}} / розряд {{d}} МВт",
  "ak_sd_delivery_ceiling_mw": "стеля відпуску {{n}} МВт",
  "ak_sd_each_role_sees_its_own_screen_the_swit": "Кожна роль бачить свій екран. Перемикач тут лише для того, щоб показати всі три в одному посиланні.",
  "ak_sd_area_of_responsibility": "Зона відповідальності:",
  "ak_sd_uah_mwh": "грн/МВт·год",
  "ak_sd_the_agent": "Агент",
  "ak_sd_does_not_draw_numbers_itself": "не малює числа сам",
  "ak_sd_it_translates_the_request_into_a_param": ": він перекладає прохання в параметр і просить той самий рушій перерахувати графік. Нижче — що саме зміниться.",
  "ak_sd_the_model_does_not_promise_an_exact_pr": "Модель не обіцяє точну ціну в гривнях — вона впорядковує години. Для вибору вікна розряду цього достатньо, і це можна перевірити за фактом.",
  "ak_sd_vadym_s_question_from_the_12_10_meetin": "Питання Вадима з наради 12.10. Рахуємо на чотирьох числах: ціна РДН, вартість диспетчеризації, очікувана ціна профіциту БР і частка сальдування в цій годині.",
  "ak_sd_a_zero_in_the_schedule_means_the_plant": "Нуль у графіку означає, що станція має фізично припинити відпуск. Це домовленість із технічною службою, а не лише цифра в таблиці.",
  "ak_sd_repair": "ремонт",
  "ak_sd_connectivity": "звʼязок",
  "ak_sd_restriction": "обмеження",
  "ak_sd_the_coefficient_is_applied": "Коефіцієнт накладається",
  "ak_sd_exactly_once": "рівно один раз",
  "ak_sd_and_only_because_there_is_an_event_in": "і лише тому, що в журналі є подія. Модель прогнозу навчена на фактичній генерації, де минулі аварії вже враховані — другий множник занизив би графік удвічі сильніше, ніж треба.",
  "ak_sd_mw": "{{n}} МВт",
  "ak_sd_changed_by_the_technical_dispatcher_ev": "Змінює технічний диспетчер; кожна зміна зберігається з датою, бо від неї залежать усі подальші графіки. Зимові коефіцієнти — після зустрічі з Радмиртехом.",
  "ak_sd_dispatch_room": "Диспетчерська",
  "ak_sd_trading_schedule_mockup": "Торговий графік (макет)",
  "ak_sd_mockup": "макет",
  "ak_sd_demo_data_nothing_is_sent": "демонстраційні дані, нічого не надсилається",
  "ak_sd_horizon_d_2_accuracy_noticeably_lower": "горизонт D+2, точність помітно нижча",
  "ak_sd_horizon_d_1": "горизонт D+1",
  "ak_sd_day_outside_the_submission_horizon": "доба поза горизонтом подачі",
  "ak_sd_until_mms_submission": "до подачі на MMS",
  "ak_sd_10_30_1_h_18_min": "10:30 · 1 год 18 хв",
  "ak_sd_just_now": "щойно",
  "ak_sd_all_three_approvals_are_in_the_schedul": "Усі три галочки стоять — графік іде на MMS автоматично.",
  "ak_sd_generation_forecast": "Прогноз генерації",
  "ak_sd_delivery_schedule": "Графік відпуску",
  "ak_sd_bess_charge_discharge": "Заряд / розряд УЗЕ",
  "ak_sd_expected_revenue": "Очікувана виручка",
  "ak_sd_technical_state": "Технічний стан",
  "ak_sd_median_p50": "медіана P50",
  "ak_sd_this_is_what_we_submit_to_mms": "це подаємо на MMS",
  "ak_sd_cycle_efficiency_0_87": "ККД циклу 0,87",
  "ak_sd_schedule_price_forecast_0_97": "графік × прогноз ціни × 0,97",
  "ak_sd_coefficient_0_97": "коефіцієнт 0,97",
  "ak_sd_day_by_hour": "Доба погодинно",
  "ak_sd_price_forecast": "Прогноз ціни",
  "ak_sd_corridor_p10_p90": "Коридор P10–P90",
  "ak_sd_generation_forecast_p50": "Прогноз генерації P50",
  "ak_sd_dam_price_forecast": "Прогноз ціни РДН",
  "ak_sd_discharge_window_19_00_21_00": "вікно розряду 19:00–21:00",
  "ak_sd_charge_window_11_00_14_00": "вікно заряду 11:00–14:00",
  "ak_sd_tell_the_model_what_to_change": "Сказати моделі, що змінити",
  "ak_sd_write_in_plain_language_move_the_disch": "Напишіть звичайною мовою: «перенеси розряд на 21–22, там дорожче»",
  "ak_sd_recalculate": "Перерахувати",
  "ak_sd_move_the_discharge_to_21_22": "перенеси розряд на 21–22",
  "ak_sd_apply_the_16_mw_limit_from_hour_14": "врахуй обмеження 16 МВт з 14-ї години",
  "ak_sd_do_not_set_zero_at_hour_14_give_the_re": "не став нуль у 14-й, віддай залишок у мережу",
  "ak_sd_show_why_exactly_these_two_discharge_h": "покажи, чому саме ці дві години розряду",
  "ak_sd_the_model_proposes_a_change_confirm_or": "Модель пропонує зміну — підтвердьте або скасуйте",
  "ak_sd_discharge_window": "Вікно розряду",
  "ak_sd_imbalance_risk": "Ризик небалансу",
  "ak_sd_uah_1_198k": "1 198 тис. грн",
  "ak_sd_uah_1_186k": "1 186 тис. грн",
  "ak_sd_low": "низький",
  "ak_sd_medium": "середній",
  "ak_sd_apply": "Застосувати",
  "ak_sd_cancel": "Скасувати",
  "ak_sd_the_request_and_decision_will_be_logge": "Запит і рішення потраплять у журнал: хто просив, що змінилось, чим це закінчилось за фактом доби.",
  "ak_sd_accuracy_over_7_days": "Точність за 7 діб",
  "ak_sd_12_0_nmae": "12,0 % nMAE",
  "ak_sd_target_7": "ціль ≤ 7 %",
  "ak_sd_worst_day": "Найгірша доба",
  "ak_sd_change_vs_evening": "Зміна до вечірнього",
  "ak_sd_morning_forecast_is_higher_alarm_at_08": "ранковий прогноз вищий — алярм о 08:30",
  "ak_sd_corridor_width": "Ширина коридору",
  "ak_sd_variable_cloud_cover": "змінна хмарність",
  "ak_sd_hours_worth_a_look": "Години, на які варто глянути",
  "ak_sd_hour": "Година",
  "ak_sd_forecast_p50": "Прогноз P50",
  "ak_sd_corridor": "Коридор",
  "ak_sd_schedule": "Графік",
  "ak_sd_why": "Чому так",
  "ak_sd_peak_hour_hit_rate": "Влучання в пікову годину",
  "ak_sd_23_of_30_days": "23 з 30 діб",
  "ak_sd_for_september": "за вересень",
  "ak_sd_most_expensive_hour": "Найдорожча година",
  "ak_sd_uah_mwh_corridor_20": "грн/МВт·год, коридор ±20 %",
  "ak_sd_cheapest_hour": "Найдешевша година",
  "ak_sd_we_put_the_charge_here": "сюди ставимо заряд",
  "ak_sd_daily_spread": "Розрив дня",
  "ak_sd_between_the_most_and_least_expensive": "між найдорожчою й найдешевшою",
  "ak_sd_hour_ranking_by_price": "Ранг годин за ціною",
  "ak_sd_cheap_hours_zero_or_give": "Дешеві години: нуль чи віддати?",
  "ak_sd_dam_price": "Ціна РДН",
  "ak_sd_give": "Віддати",
  "ak_sd_zero": "Нуль",
  "ak_sd_decision": "Рішення",
  "ak_sd_1_2k": "+1,2 тис.",
  "ak_sd_0_4k": "−0,4 тис.",
  "ak_sd_0_3k": "+0,3 тис.",
  "ak_sd_give_2": "віддати",
  "ak_sd_zero_2": "нуль",
  "ak_sd_inverters": "Інвертори",
  "ak_sd_2_at_tko_3_under_repair": "2 на ТКО-3 у ремонті",
  "ak_sd_usable_bess_capacity": "Корисна ємність УЗЕ",
  "ak_sd_soc_now": "SOC зараз",
  "ak_sd_average_across_16_pcs": "середнє по 16 PCS",
  "ak_sd_tso_restriction": "Обмеження ОСП",
  "ak_sd_none": "немає",
  "ak_sd_event_log_basis_for_the_coefficient": "Журнал подій — підстава для коефіцієнта",
  "ak_sd_affects_the_schedule": "впливає на графік",
  "ak_sd_does_not_affect_the_schedule": "на графік не впливає",
  "ak_sd_availability_coefficient": "Коефіцієнт доступності",
  "ak_sd_62_64_inverters": "= 62 / 64 інвертори",
  "ak_sd_rated_parameters": "Паспортні параметри",
  "ak_sd_charge_power": "Потужність заряду",
  "ak_sd_discharge_power": "Потужність розряду",
  "ak_sd_cycle_efficiency": "ККД циклу",
  "ak_sd_delivery_ceiling": "Стеля відпуску",
};

export default translations;
